import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import {
  Product,
  ProductType,
  SRouterLinkWithHrefDirective,
  TranslateDirective,
  TranslatePipe,
} from '@speedy/core';
import { PriceComponent } from '../../../price/price.component';
import { CurrencyComponent } from '../../../currency/currency.component';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
  selector: 'app-autocomplete-products-list',
  templateUrl: './autocomplete-products-list.component.html',
  styleUrls: ['./autocomplete-products-list.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    SRouterLinkWithHrefDirective,
    CurrencyComponent,
    PriceComponent,
    TranslatePipe,
    AsyncPipe,
  ],
})
export class AutocompleteProductsListComponent implements OnChanges {
  @Input() isSingleView = false;

  @Input() products!: Product[];

  @Output() toggleAutocomplete = new EventEmitter<void>();

  @Output() hoverProductItem = new EventEmitter<Product>();

  hoveredProduct!: Product;

  ProductType = ProductType;

  ngOnChanges(changes: SimpleChanges): void {
    this.hoverProduct(changes.products.currentValue[0]);
  }

  hoverProduct(product: Product) {
    this.hoverProductItem.emit(product);
    this.hoveredProduct = product;
  }
}
